import { Users } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Accordion, ToggleFieldGroup } from "@/components/customer/events";
import { useTranslation } from "@/hooks/useTranslation";

interface ParentsGodparentsAccordionProps {
  brideParent1: string;
  brideParent2: string;
  groomParent1: string;
  groomParent2: string;
  godparent1: string;
  godparent2: string;
  brideParentsEnabled: boolean;
  groomParentsEnabled: boolean;
  godparentsEnabled: boolean;
  includesBaptism?: boolean;
  onBrideParent1Change: (value: string) => void;
  onBrideParent2Change: (value: string) => void;
  onGroomParent1Change: (value: string) => void;
  onGroomParent2Change: (value: string) => void;
  onGodparent1Change: (value: string) => void;
  onGodparent2Change: (value: string) => void;
  onBrideParentsEnabledChange: (enabled: boolean) => void;
  onGroomParentsEnabledChange: (enabled: boolean) => void;
  onGodparentsEnabledChange: (enabled: boolean) => void;
}

export function ParentsGodparentsAccordion({
  brideParent1,
  brideParent2,
  groomParent1,
  groomParent2,
  godparent1,
  godparent2,
  brideParentsEnabled,
  groomParentsEnabled,
  godparentsEnabled,
  includesBaptism = false,
  onBrideParent1Change,
  onBrideParent2Change,
  onGroomParent1Change,
  onGroomParent2Change,
  onGodparent1Change,
  onGodparent2Change,
  onBrideParentsEnabledChange,
  onGroomParentsEnabledChange,
  onGodparentsEnabledChange,
}: ParentsGodparentsAccordionProps) {
  const { t } = useTranslation();
  return (
    <Accordion
      title={t(includesBaptism ? "events.form.parents.titleBaptism" : "events.form.parents.title")}
      icon={<Users className="h-6 w-6 text-pink-600 dark:text-pink-400" />}
      defaultOpen={false}
    >
      <div className="space-y-6">
        <ToggleFieldGroup
          label={t("events.form.parents.brideParents")}
          checked={brideParentsEnabled}
          onCheckedChange={onBrideParentsEnabledChange}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="bride-parent-1">{t("events.form.parents.parent1")}</Label>
              <Input
                id="bride-parent-1"
                value={brideParent1}
                onChange={(e) => onBrideParent1Change(e.target.value)}
                placeholder={t("events.form.parents.parent1")}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="bride-parent-2">{t("events.form.parents.parent2")}</Label>
              <Input
                id="bride-parent-2"
                value={brideParent2}
                onChange={(e) => onBrideParent2Change(e.target.value)}
                placeholder={t("events.form.parents.parent2")}
                className="mt-1"
              />
            </div>
          </div>
        </ToggleFieldGroup>

        <ToggleFieldGroup
          label={t("events.form.parents.groomParents")}
          checked={groomParentsEnabled}
          onCheckedChange={onGroomParentsEnabledChange}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="groom-parent-1">{t("events.form.parents.parent1")}</Label>
              <Input
                id="groom-parent-1"
                value={groomParent1}
                onChange={(e) => onGroomParent1Change(e.target.value)}
                placeholder={t("events.form.parents.parent1")}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="groom-parent-2">{t("events.form.parents.parent2")}</Label>
              <Input
                id="groom-parent-2"
                value={groomParent2}
                onChange={(e) => onGroomParent2Change(e.target.value)}
                placeholder={t("events.form.parents.parent2")}
                className="mt-1"
              />
            </div>
          </div>
        </ToggleFieldGroup>

        <ToggleFieldGroup
          label={t("events.form.parents.godparents")}
          checked={godparentsEnabled}
          onCheckedChange={onGodparentsEnabledChange}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="godparent-1">{t("events.form.parents.godparent1")}</Label>
              <Input
                id="godparent-1"
                value={godparent1}
                onChange={(e) => onGodparent1Change(e.target.value)}
                placeholder={t("events.form.parents.godparent1")}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="godparent-2">{t("events.form.parents.godparent2")}</Label>
              <Input
                id="godparent-2"
                value={godparent2}
                onChange={(e) => onGodparent2Change(e.target.value)}
                placeholder={t("events.form.parents.godparent2")}
                className="mt-1"
              />
            </div>
          </div>
        </ToggleFieldGroup>
      </div>
    </Accordion>
  );
}

